"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const sharedStyles_1 = require("components/TransactionRegister/sharedStyles");
const styles_1 = require("./styles");
exports.default = (theme) => ({
    checkbox: {
        margin: '10px 0 0',
        '& >div': {
            paddingLeft: 0,
        },
    },
    defaultOverride: {
        color: theme.palette.text.strong,
        cursor: 'default',
        borderBottom: `0.5px solid ${theme.palette.divider}`,
    },
    editableClass: Object.assign(Object.assign({}, (0, sharedStyles_1.regItem)(theme)), { background: theme.palette.background.subtle, border: `1px solid ${theme.palette.divider}`, marginBottom: 0, marginTop: 0, marginRight: 0, marginLeft: 0, '& input': Object.assign(Object.assign({}, (0, sharedStyles_1.regItemCore)(theme)), { height: 24, padding: 0 }) }),
    lockIcon: Object.assign({}, styles_1.lockIcon),
    lockWrapper: {
        display: 'grid',
    },
    lockSubText: {
        justifySelf: 'center',
        '& svg': {
            width: theme.typography.body2.fontSize,
        },
    },
    nonEditableClass: {
        '& p': Object.assign({}, (0, sharedStyles_1.regItemCore)(theme)),
    },
    amountLabel: {
        textAlign: 'right',
        fontSize: 14,
    },
    rowWrapper: {
        '&:hover': {
            backgroundColor: theme.palette.divider,
        },
    },
    row: Object.assign(Object.assign({ position: 'relative' }, (0, styles_1.gridTable)(theme.palette)), { '& .split-section': {
            gridColumn: '1 / -1',
            backgroundColor: theme.palette.background.paper,
            border: `1px solid ${theme.palette.divider}`,
            display: 'grid',
            gridTemplateColumns: '30% auto',
            padding: 20,
        } }),
    validSubmitIcon: {
        color: theme.palette.success.main,
    },
    payeeRoot: {
        background: theme.palette.background.paper,
        marginTop: 8,
    },
    payeeInput: {
        paddingTop: '0 !important',
        paddingBottom: '0 !important',
        '&:hover': {},
    },
    payeeLabel: {
        fontSize: 14,
    },
    payeeLabelOutline: {
        transform: 'translate(14px, 6px) scale(1)',
    },
    payeeAutocompleteInput: {
        paddingTop: '0 !important',
        paddingBottom: '0 !important',
        height: 28,
        fontSize: 14,
        '&::placeholder': {
            textOverflow: 'ellipsis !important',
            // color: theme.palette.text.primary,
        },
    },
});
